var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-popup" }, [
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "remotePaymentStart",
          tabindex: "-1",
          role: "dialog",
          "aria-hidden": "true",
        },
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-dialog modal-dialog-centered",
            attrs: { role: "document" },
          },
          [
            _vm.booking != null
              ? _c("div", { staticClass: "modal-content" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-body" }, [
                    _c("div", { staticClass: "contact-form-action" }, [
                      _c("form", { attrs: { method: "post" } }, [
                        _c("div", { staticClass: "row" }, [
                          _vm.projectName !== "selectum"
                            ? _c("div", { staticClass: "col-sm-6" }, [
                                _c("div", { staticClass: "input-box" }, [
                                  _c("label", { staticClass: "label-text" }, [
                                    _vm._v("Tutar"),
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.remotePayment.paymentAmount,
                                        expression:
                                          "remotePayment.paymentAmount",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      id: "paymentAmount",
                                      type: "number",
                                      placeholder: "",
                                    },
                                    domProps: {
                                      value: _vm.remotePayment.paymentAmount,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.remotePayment,
                                          "paymentAmount",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-sm-12" }, [
                            _vm.paymentUrl
                              ? _c("div", { staticClass: "input-box" }, [
                                  _c("label", { staticClass: "label-text" }, [
                                    _vm._v("Payment Url"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "label-text text-color-7",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.copyToClipboard(
                                            _vm.paymentUrl
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Adresi Kopyala")]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.paymentUrl,
                                        expression: "paymentUrl",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      disabled: "",
                                      id: "paymentUrl",
                                      type: "text",
                                      placeholder: "",
                                    },
                                    domProps: { value: _vm.paymentUrl },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.paymentUrl = $event.target.value
                                      },
                                    },
                                  }),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.projectName !== "selectum"
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "input-box d-flex align-items-center",
                                  },
                                  [
                                    _c("label", { staticClass: "label-text" }, [
                                      _vm._v("Non Secure"),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.remotePayment.nonSecure,
                                          expression: "remotePayment.nonSecure",
                                        },
                                      ],
                                      staticClass: "form-control ",
                                      staticStyle: { width: "5rem" },
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.remotePayment.nonSecure
                                        )
                                          ? _vm._i(
                                              _vm.remotePayment.nonSecure,
                                              null
                                            ) > -1
                                          : _vm.remotePayment.nonSecure,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a = _vm.remotePayment.nonSecure,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  _vm.remotePayment,
                                                  "nonSecure",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  _vm.remotePayment,
                                                  "nonSecure",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.remotePayment,
                                              "nonSecure",
                                              $$c
                                            )
                                          }
                                        },
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-footer border-top-0 pt-0" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn font-weight-bold font-size-15 color-text-2 mr-2",
                        attrs: { type: "button", "data-dismiss": "modal" },
                      },
                      [_vm._v("Cancel")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "theme-btn theme-btn-small",
                        attrs: { type: "button" },
                        on: { click: _vm.accept },
                      },
                      [_vm._v("Onaylıyorum")]
                    ),
                  ]),
                ])
              : _vm._e(),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h3", { staticClass: "title mt-2 ml-2" }, [_vm._v("Uzaktan Ödeme")]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close",
          },
        },
        [
          _c("span", {
            staticClass: "la la-close",
            attrs: { "aria-hidden": "true" },
          }),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }